import { render, staticRenderFns } from "./pdd.vue?vue&type=template&id=31fbd782&"
import script from "./pdd.vue?vue&type=script&lang=js&"
export * from "./pdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports